<template>
  <div id="poster" class="center">
    <div class="flex loginbox">
      <div v-if="!$bus.isPhone" style="width: 500px">
        <img src="../assets/img/loginbg1.png" style="width: 500px; height:100%" />
      </div>
      <div :class="`l-r center `">
        <img src="../assets/img/logo1.png" />
        <h3 class="login_title">青岛八大关近代建筑<br />预防性保护平台</h3>
        <!-- <span class="login_sub">专业的消防服务机构，让消防技术服务更便捷</span> -->
        <el-form class="login-container" label-position="left" label-width="0px" :model="user" :rules="rules" ref="user">
          <el-form-item prop="tr_login_account    ">
            <el-input prefix-icon="el-icon-user" type="text" v-model="user.username" auto-complete="off" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item prop="tr_login_pass">
            <el-input prefix-icon="el-icon-lock" type="password" v-model="user.password" auto-complete="off" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
          <!-- <el-form-item prop="code" v-if="flag == 1">
            <el-col :span="15">
              <el-input
                prefix-icon="el-icon-document-checked "
                v-model="user.code"
                auto-complete="off"
                placeholder="请输入验证码"
                style="width: 300px"
              ></el-input>
            </el-col>
            <el-button
              plain
              class="getCheck"
              :disabled="disabled"
              @click="getCheck"
              v-if="disabled == false"
              >获取验证码</el-button
            >
            <el-button
              plain
              class="getCheck"
              :disabled="disabled"
              @click="getCheck"
              v-if="disabled == true"
              >{{ btntxt }}</el-button
            >
          </el-form-item> -->
          <el-form-item class="center f-right">
            <el-checkbox label="记住账号" v-model="saveNumber">记住账号</el-checkbox>
            <el-checkbox label="记住密码" v-model="savePass">记住密码</el-checkbox>
            <!-- <span
              @click="status"
              v-if="flag == 0"
              class="getCheck"
              style="margin-left: 10px; cursor: pointer; color: #2b74ea"
              >手机号登录</span
            >
            <span
              @click="status"
              v-if="flag == 1"
              class="getCheck"
              style="margin-left: 10px; cursor: pointer; color: #2b74ea"
              >密码登录</span
            > -->
          </el-form-item>
          <div class="login-btn" @click="submit">登 录</div>
          <!-- <div class="center mt10 erma"><img src="../assets/img/erweima.png"></div>  -->
          <!-- <div class="center extra_message">没有登录账号？<router-link :to="'/register'" tag="span">点击注册</router-link></div> -->
          <div class="center extra_message">
            <el-checkbox v-model="agreement" style="margin-right: 8px" size="mini" />阅读并同意<span @click="agreeModule = true">《服务协议》</span>
          </div>
          <!-- <copyright ></copyright>     -->
          <div class="footer center">
            &copy;青岛同人建筑防火有限公司 &nbsp;
            <span class="ml10"> <a href="https://beian.miit.gov.cn">鲁ICP备17044344号-1</a></span>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog class="agre" title="青岛同人用户服务协议" :visible.sync="agreeModule" width="50%">
      <div style="margin-top: 20px" v-for="(item, index) of agreetext" :key="index">
        <h4>{{ item.title }}</h4>
        <div style="margin-top:5px;text;text-indent:2em" v-for="(ite, idx) of item.detail" :key="idx">
          <p style="margin-top: 5px">{{ ite.content }}</p>
          <div style="margin-top: 5px; text-indent: 3em" v-for="(it, id) of ite.detail" :key="id" :v-if="ite.detail">
            <p style="margin-top: 5px">{{ it.content }}</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer center">
        <el-button @click="agreecancle">拒 绝</el-button>
        <el-button type="primary" @click="agree">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import agreetext from "./agreement";

import { login, getWeihu } from "../api/common.js";
export default {
  components: {},
  data() {
    return {
      user: {
        username: "",
        password: "",
      },
      agreement: false,
      agreetext,
      agreeModule: false,
      flag: 0,
      rules: {
        username: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
      },
      savePass: true,
      saveNumber: true,
      loading: false,
    };
  },
  mounted() {},
  created() {
    if (this.$local.get("token")) {
      this.$router.replace("/");
    }
    if (this.$local.get("account")) {
      this.user = this.$local.get("account");
    }
    this.$local.remove("countList");
    this.$local.remove("bjstate");
    document.onkeydown = (e) => {
      //按下回车提交
      let key = window.event.keyCode;
      //事件中keycode=13为回车事件
      if (key == 13) {
        this.submit();
      }
    };
  },
  methods: {
    agreecancle() {
      alert("请同意用户协议使用");

      this.agreement = false;
      this.agreeModule = false;
    },
    agree() {
      this.agreeModule = false;
      this.agreement = true;
    },
    submit() {
      if (!this.agreement) {
        this.$message.warning("请同意服务协议");
        return;
      }
      this.$refs["user"].validate((valid) => {
        if (valid) {
          if (this.savePass) {
            this.$local.save("account", this.user);
          } else {
            this.$local.remove("account");
          }
          this.login();
        } else {
          return false;
        }
      });
    },
    login() {
      this.loading = true;
      // this.$loading;

      //      var obj = this.$store.state.weihutime
      //   if(obj.endtime && obj.starttime && !this.$store.state.isDev ) {
      //           this.$alert(`尊敬的客户,我们将于 ${obj.starttime} 至 ${obj.endtime} 进行系统升级维护，维护期间系统暂时无法登入，给您造成不便，敬请谅解。`, '公告', {
      //       confirmButtonText: '确定',

      //     });
      //      }

      this.$store
        .dispatch("Login", this.user)
        .then((res) => {
          this.$router.push("/");
          setTimeout(() => {
            window.location.reload();
          }, 800);
        })
        .catch((er) => {
          // alert(er)
          this.loading = false;
          // this.getCode();
        });
      //    login(this.user).then(res=>{
      //         this.loading = false
      //         if(res.code==200){
      //             this.$message({
      //                 message: res.msg,
      //                 type: 'success'
      //             });
      //             if(this.savePass){
      //                 this.$local.save('account',this.user)
      //             }else{
      //                 this.$local.remove('account')
      //             }
      //             this.$store.commit('saveUser',res.data)
      //             //window.location.href = '/'
      //             this.$router.push('/')
      //         }
      //     }).catch(res=>{
      //         this.loading = false
      //         //this.$message.error('登录失败！')
      //     })
    },
  },
};
</script>
<style lang="scss" scoped>
.erma {
  img {
    width: 110px;
  }
}
.footer {
  font-size: 14px;
  bottom: 20px;
  position: absolute;
  a {
    text-decoration: underline;
    color: rgb(123, 123, 123);
  }
}
#poster {
  background: url("../assets/img/bg1.png");
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  .phone {
    padding: 20px 40px !important;
    .login-container {
      width: 280px;
    }
    .login_title {
      font-size: 24px;
    }
  }
  .loginbox {
    border-radius: 10px;
    overflow: hidden;
    .l-r {
      background: #fff;
      padding: 40px 80px;
      flex-direction: column;
    }
    .el-input {
      line-height: 50px;
      height: 50px;
      input {
        height: 50px;
      }
    }
  }
  .getCheck {
    height: 50px;
    float: right;
  }
  .login-container {
    width: 400px;
  }
  .login_sub {
    font-size: 14px;
    color: #2b74ea;
    margin-bottom: 40px;
  }
  .login_title {
    margin: 25px auto 10px auto;
    text-align: center;
    color: #3d62de;
    font-size: 28px;
  }
  .login-btn {
    margin-top: 30px;
    width: 100%;
    height: 58px;
    line-height: 58px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    background-image: linear-gradient(to right, #2b74ea, #56ccf2);
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.3s;
    &:hover {
      opacity: 0.8;
    }
  }
  .extra_message {
    font-size: 14px;
    margin: 15px 0;
    el-checkbox {
      margin-right: 5px;
    }
    span {
      color: #2b74ea;
      cursor: pointer;
    }
  }
  .agre {
    line-height: 20px;
    letter-spacing: 1px;
  }
}
</style>
